import { jsx } from 'react/jsx-runtime';
import '../../assets/indicators/loaderDots.svg.mjs';
import '../StyleableSvgImage/index.mjs';
import { Wrap, SIZES } from './LoaderDots.styles.mjs';
import { StyleableSvgImage } from '../StyleableSvgImage/StyleableSvgImage.mjs';
import LoaderDotsSvg__default from "../../assets/loaderDots.svg";
"use strict";
const LoaderDots = function LoaderDots2({
  size = "medium",
  color
}) {
  return /* @__PURE__ */jsx(Wrap, {
    size,
    color,
    children: /* @__PURE__ */jsx(StyleableSvgImage, {
      src: LoaderDotsSvg__default,
      width: SIZES[size].width,
      height: SIZES[size].height
    })
  });
};
export { LoaderDots };
//# sourceMappingURL=LoaderDots.mjs.map
